import { atom } from 'jotai';

import { appointmentInfoAtom } from '../state';

const STORAGE_KEY_PREFIX = 'softBlockResolved:';

function getStorageKey(appointmentShortId: string): string {
  return `${STORAGE_KEY_PREFIX}${appointmentShortId}`;
}

const revisionAtom = atom(0);

const inMemorySoftBlockResolvedAtom = atom(false);

// Reads localStorage directly rather than via atomWithStorage: one-shot reads
// don't mount the atom, and this jotai version lacks getOnInit, so storage
// would never hydrate before the routing decision runs on refresh.
export const isSoftBlockResolvedAtom = atom(
  (get) => {
    get(revisionAtom);
    const appointmentShortId = get(appointmentInfoAtom)?.shortId;
    if (!appointmentShortId) return get(inMemorySoftBlockResolvedAtom);
    return localStorage.getItem(getStorageKey(appointmentShortId)) === 'true';
  },
  (get, set, value: boolean) => {
    const appointmentShortId = get(appointmentInfoAtom)?.shortId;
    if (!appointmentShortId) {
      set(inMemorySoftBlockResolvedAtom, value);
      return;
    }
    localStorage.setItem(getStorageKey(appointmentShortId), String(value));
    set(revisionAtom, (revision) => revision + 1);
  },
);
